<template>
  <v-card
    class="spotlight-card"
    elevation="0"
  >
    <!-- ───────────── TOP ROW ───────────── -->
    <div class="event-top-row">

      <!-- Host -->
      <div class="host-section">
        <div class="host-avatar-wrapper">
          <v-avatar size="30">
            <img src="../assets/prof1.jpg" :alt="host.name">
          </v-avatar>

          <!-- Online indicator -->
          <span
            v-if="host.online"
            class="online-dot"
          ></span>
        </div>

        <div class="host-label">
          {{ host.label || 'Host' }}
        </div>
      </div>

      <!-- Start time / menu -->
      <div class="event-actions">
        <span class="start-time">
          <span class="bullet">•</span>
          {{ startText }}
        </span>

        <v-btn
          icon
          small
          color="white"
          @click="$emit('menu-click')"
        >
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- ───────────── TITLE + IMAGE ───────────── -->
    <div class="event-middle">

      <div class="event-title">
        {{ title }}
      </div>

      <v-img
        src="../assets/assimi.jpeg"
        class="event-image"
        cover
      ></v-img>
    </div>

    <!-- ───────────── PEOPLE WAITING ───────────── -->
    <div class="waiting-section">

      <div class="avatar-stack">
        <v-avatar
            v-for="(person, index) in people"
            :key="person.id || index"
            size="30"
            class="stack-avatar"
        >
          <img
            :src="person"
            :alt="person.name"
          >
        </v-avatar>
      </div>

      <div class="waiting-text">
        <strong v-if="attendees.length">
          {{ attendees[0].name }}
        </strong>

        <span v-if="waitingCount > 0">
          +{{ formattedWaitingCount }} people waiting
        </span>
      </div>
    </div>

    <!-- ───────────── SCHEDULE BUTTON ───────────── -->
    <v-btn
      block
      outlined
      rounded
      class="scheduled-button"
      @click="$emit('button-click')"
    >
      <span>{{ buttonText }}</span>

      <v-icon class="alarm-icon">
        mdi-alarm
      </v-icon>
    </v-btn>
  </v-card>
</template>


<script>
export default {
  name: 'spotlight-card',
    data() {
    return {
        people: [
        require('../assets/prof6.jpg'),
        require('../assets/prof7.jpg'),
        require('../assets/prof8.jpg')
        ]
    }
},
  props: {
    host: {
      type: Object,
      default: () => ({
        name: 'Host',
        label: 'Host',
        avatar: '',
        online: true
      })
    },

    title: {
      type: String,
      default: 'The AES: Currency, Indigenous Army, Where to Next?'
    },

    startText: {
      type: String,
      default: 'Starts in 1d 34 mins...'
    },

    eventImage: {
      type: String,
      default: ''
    },

    attendees: {
      type: Array,
      default: () => [

      ]
    },

    waitingCount: {
      type: Number,
      default: 15000
    },

    buttonText: {
      type: String,
      default: 'Scheduled'
    }
  },

  computed: {
    formattedWaitingCount() {
      if (this.waitingCount >= 10000) {
        return Math.floor(this.waitingCount / 1000) + 'k+'
      }

      return this.waitingCount
    }
  }
}
</script>


<style scoped>
.spotlight-card {
  position: relative;

  max-width: 800px;

  min-height: 200px;

  padding: 10px 28px 28px 20px;

  background: #2c9998 !important;

  color: white;

  border-radius: 10px !important;

  overflow: hidden;
}


/* ─────────────────────────────
   TOP ROW
───────────────────────────── */

.event-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
}

.host-section {
  display: flex;
  align-items: center;

  gap: 10px;
}

.host-avatar-wrapper {
  position: relative;
}

.host-label {
  border: 1px solid rgba(255,255,255,.9);

  padding: 2px 5px;

  font-size: 15px;
  font-weight: 600;

  line-height: 1;

  color: white;
}

.online-dot {
  position: absolute;

  top: -1px;
  right: -1px;

  width: 14px;
  height: 14px;

  background: #00c853;

  border: 2px solid white;

  border-radius: 50%;
}

.event-actions {
  display: flex;
  align-items: center;

  gap: 8px;
}

.start-time {
  font-size: 13px;
  font-weight: 400;

  white-space: nowrap;
}

.bullet {
  font-size: 16px;
  margin-right: 4px;
}


/* ─────────────────────────────
   TITLE
───────────────────────────── */

.event-middle {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  margin-top: 10px;

  gap: 20px;
}

.event-title {
  max-width: 620px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.05;
  color: white;
}

.event-image {
  flex-shrink: 0;
  width: 80px;
  height: 62px;
  border-radius: 16px;
}


/* ─────────────────────────────
   WAITING USERS
───────────────────────────── */

.waiting-section {
  display: flex;
  align-items: center;
  min-height: 45px;
}

.avatar-stack {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.stack-avatar {
  margin-left: -8px;
  border: 2px solid white !important;
}

.stack-avatar:first-child {
  margin-left: 0;
}

.waiting-text {
  display: flex;
  align-items: center;

  gap: 6px;

  font-size: 17px;

  white-space: nowrap;
}

.waiting-text strong {
  font-weight: 700;
}


/* ─────────────────────────────
   BUTTON
───────────────────────────── */

.scheduled-button {
  height: 40px !important;

  margin-top: 2px;

  border: 1.5px solid white !important;

  color: white !important;

  font-size: 20px !important;
  font-weight: 700 !important;

  text-transform: none !important;

  background: transparent !important;
}

.alarm-icon {
  margin-left: 3px;

  font-size: 14px !important;
}


/* ─────────────────────────────
   MOBILE
───────────────────────────── */

@media (max-width: 600px) {

  .spotlight-card {
    padding: 10px 18px 10px 20px;

    border-radius: 10px !important;

  }

  .start-time {
    font-size: 15px;
  }

  .host-label {
    font-size: 18px;
  }

  .event-title {
    font-size: 22px;
  }

  .event-image {
    width: 90px;
    height: 76px;
  }

  .waiting-text {
    font-size: 19px;
  }

  .scheduled-button {
    height: 50px !important;

    font-size: 20px !important;
  }
}
</style>